import { CheckIcon } from '@heroicons/react/24/outline';
import React, { useId } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useModalDialog } from 'reusable/useModalDialog';

interface SaveChangesDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const SaveChangesDialog: React.FC<SaveChangesDialogProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const handleOkClick = () => {
    onClose();
    navigate('/client');
  };

  // ADM-16。名前（見出し）・Escape・フォーカスの閉じ込めと戻し。
  const titleId = useId();
  // RV-126。Escape も OK と同じ完了の処理（一覧へ戻る）にする。閉じるだけだと保存した編集の
  // 画面に残り、もう一度送れた。
  const dialogRef = useModalDialog(isOpen, handleOkClick);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
      <div
        className="flex flex-col py-4 bg-white rounded-md shadow-lg w-1/3"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        ref={dialogRef}
        tabIndex={-1}
      >
        <div className="flex justify-start px-4 pb-4">
          <h4 id={titleId} className="text-title">{t('ui.success', { ns: 'common' })}</h4>
        </div>
        <div className="border-y w-full flex flex-col items-center justify-center py-4">
          <CheckIcon className="bg-[#67B926] rounded-full text-white h-24 p-4" />
          <p className="py-4 text-center whitespace-nowrap">
            {t('ui.changes-saved', { ns: 'client' })}
          </p>
        </div>
        <div className="flex justify-end mt-4 w-full px-4">
          <button type="button"
            className="bg-primary/300 text-white w-full py-2 rounded-md"
            onClick={handleOkClick}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveChangesDialog;
